module.exports = require('./helpers/bundle-url').getBundleURL('hdhZv') + "walnut-dune-timber-kimberly-0.7d0cfe13.jpg";